<template>
  <div>
    <h4> Image </h4>
    <div v-if="activeImage" class="my-3">
      <div class="fields-wrapper is-divider">
        <div class="row">
          <div class="col-6">
            <div class="row form-group align-items-center">
              <label for="animation_selector" class="col-sm-3 col-form-label">
                Image Selector
              </label>
              <div class="col-sm-9">
                <select id="animation_selector"
                  v-model="activeImage.objectDbHash"
                  class="custom-select"
                  @change="changeSelectedImage(event)"
                >
                  <option v-for="(imageSelector, key) in getMediaImages"
                          :key="key"
                          class="custom-select"
                          :value="key">
                    {{ imageSelector.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="row form-group align-items-center">
              <label class="col-sm-3 col-form-label">
                Display Type
              </label>
              <div class="col-sm-9">
                <select
                  placeholder="Select Media Type"
                  class="custom-select"
                  v-model="activeImage.displayType">
                  <option value="Scene">Scene</option>
                  <option value="Screen">Screen</option>
                </select>
              </div>
            </div>
            <div class="row form-group align-items-center">
              <label for="start_time" class="col-sm-3 col-form-label">
                Start Time
              </label>
              <div class="col-sm-9">
                <input type="text" class="form-control" id="start_time" v-model="activeImage.startTime" @change="changeTime">
              </div>
            </div>
            <div class="row form-group align-items-center">
              <label for="end_time" class="col-sm-3 col-form-label">
                End Time
              </label>
              <div class="col-sm-9">
                <input type="text" class="form-control" id="end_time" v-model="activeImage.endTime" @change="changeTime">
              </div>
            </div>
            <div class="row form-group align-items-center">
              <label class="col-sm-3 col-form-label">
                Duration
              </label>
              <div class="col-sm-9">
                <input type="text" :value="(parseFloat(activeImage.endTime) - parseFloat(activeImage.startTime)).toFixed(2)" class="form-control" id="image_duration_e" :class="{'border-danger': (parseFloat(activeImage.endTime) - parseFloat(activeImage.startTime)).toFixed(2) <= 0}" readonly>
              </div>
            </div>
            <div class="row form-group align-items-center">
              <label class="col-sm-3 col-form-label">
                Media size
              </label>
              <div class="col-sm-9">
                <div class="d-flex justify-content-start">
                  <div class="col-6 d-flex justify-content-start">
                     <span class="p-2">Width</span>
                    <input
                      type="number"
                      class="form-control"
                      id="mediaWidth"
                      v-model="activeImage.objectSizeDelta.width"
                    />
                  </div>
                  <div class="col-6 d-flex justify-content-start">
                    <span class="p-2">Height</span>
                    <input
                      type="number"
                      class="form-control"
                      id="mediaHeight"
                      v-model="activeImage.objectSizeDelta.height"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="row form-group align-items-center">
              <label class="col-sm-4 col-form-label">
                Scale
              </label>
              <div class="col-sm-8">
                <input type="range" min="0" max="1" step="0.1" v-model="activeImage.scale">
                <span class="ml-2">{{ activeImage.scale }}</span>
              </div>
            </div>
            <div class="row form-group align-items-center">
              <label class="col-sm-4 col-form-label">
                Layer
              </label>
              <!-- <div class="col-sm-8">
                <input type="range" min="0" max="10" step="0.5" v-model="activeImage.layer" :readonly="activeImage.displayType == 'Scene'">
                <span class="ml-2">{{ activeImage.layer }}</span>
              </div> -->
              <div class="btn-group dropright col-sm-4">
                <button type="button" class="btn btn-light dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  Select an action
                </button>
                <div class="dropdown-menu">
                  <a class="dropdown-item" :class="activeImage.layer >= layerStep ? 'disabled action-disabled' : ''" @click="bringToFront()">Bring to front</a>
                  <a class="dropdown-item" :class="activeImage.layer >= layerStep ? 'disabled action-disabled' : ''" @click="changeLayer(1)">Bring forward</a>
                  <a class="dropdown-item" :class="activeImage.layer <= -layerStep ? 'disabled action-disabled' : ''" @click="changeLayer(-1)">Send backward</a>
                  <a class="dropdown-item" :class="activeImage.layer <= -layerStep ? 'disabled action-disabled' : ''" @click="sendToBack()">Send to back</a>
                </div>
              </div>
            </div>
            <div class="row form-group align-items-center py-3" v-if="activeImage.displayType === 'Screen'">
              <label class="col-sm-4 col-form-label">
                Alignment
              </label>

              <div class="col-sm-8 align-items-center">
                <Icon icon="align_left" :color="activeImage.objectTransformSimple.horizontal == 'left' ? 'Dodgerblue' : 'white'" class="cursor-pointer mr-1" @click="horizontalAlignment('left')"/>
                <Icon icon="align_center" :color="activeImage.objectTransformSimple.horizontal == 'center' ? 'Dodgerblue' : 'white'" class="cursor-pointer mr-1" @click="horizontalAlignment('center')"/>
                <Icon icon="align_right" :color="activeImage.objectTransformSimple.horizontal == 'right' ? 'Dodgerblue' : 'white'" class="cursor-pointer mr-4" @click="horizontalAlignment('right')"/>
                <Icon icon="align_bottom" :color="activeImage.objectTransformSimple.vertical == 'bottom' ? 'Dodgerblue' : 'white'" class="cursor-pointer mr-1" @click="verticalAlignment('bottom')"/>
                <Icon icon="align_middle" :color="activeImage.objectTransformSimple.vertical == 'center' ? 'Dodgerblue' : 'white'" class="cursor-pointer mr-1" @click="verticalAlignment('center')"/>
                <Icon icon="align_top" :color="activeImage.objectTransformSimple.vertical == 'top' ? 'Dodgerblue' : 'white'" class="cursor-pointer mr-1" @click="verticalAlignment('top')"/>
   
              </div>
            </div>
            <div class="row form-group align-items-center" v-if="activeImage.displayType === 'Screen'">
              <label class="col-sm-4 col-form-label">
                Offset Horizontal
              </label>
              <div class="col-sm-8">
                <input type="text" v-model="activeImage.objectTransformSimple.offsetHorizontal" class="form-control" id="offset-horizontal">
              </div>
            </div>
            <div class="row form-group align-items-center" v-if="activeImage.displayType === 'Screen'">
              <label class="col-sm-4 col-form-label">
                Offset Vertical
              </label>
              <div class="col-sm-8">
                <input type="text" v-model="activeImage.objectTransformSimple.offsetVertical" class="form-control" id="offset-vertical">
              </div>
            </div>
            <div class="row form-group align-items-center" v-if="activeImage.displayType === 'Scene'">
            <label class="col-sm-4 col-form-label">Position of Origin</label>
            <div class="col-sm-8">
              <div class="d-flex align-items-center">
                <span class="p-2">x</span>
                <input
                  type="text"
                  class="form-control"
                  id="position_of_the_origin_x"
                  v-model="activeImage.positionOfOrigin[0]"
                />
                <span class="p-2">y</span>
                <input
                  type="text"
                  class="form-control"
                  id="position_of_the_origin_y"
                  v-model="activeImage.positionOfOrigin[1]"
                />
                <span class="p-2">z</span>
                <input
                  type="text"
                  class="form-control"
                  id="position_of_the_origin_z"
                  v-model="activeImage.positionOfOrigin[2]"
                />
              </div>
            </div>
          </div>
          <div class="row form-group align-items-center" v-if="activeImage.displayType === 'Scene'">
            <label class="col-sm-4 col-form-label">Rotation of Origin</label>
            <div class="col-sm-8">
              <div class="d-flex align-items-center">
                <span class="p-2">x</span>
                <input
                  type="text"
                  class="form-control"
                  id="rotation_of_the_origin_x"
                  v-model="activeImage.rotationOfOrigin[0]"
                />
                <span class="p-2">y</span>
                <input
                  type="text"
                  class="form-control"
                  id="rotation_of_the_origin_y"
                  v-model="activeImage.rotationOfOrigin[1]"
                />
                <span class="p-2">z</span>
                <input
                  type="text"
                  class="form-control"
                  id="rotation_of_the_origin_z"
                  v-model="activeImage.rotationOfOrigin[2]"
                />
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import {mapActions, mapGetters, mapState} from 'vuex'
import $ from 'jquery'
import {db} from '../../../../../firebaseDB'
import {uuid} from 'vue-uuid'
import Icon from '../../../../global/Icon.vue'

export default {
  components: {Icon},
  data () {
    return {
      layerStep: 10000,
      currentLoop: 0,
      currentSelectedImage: '',
      currentSelectedImageNode: '',
      showModal: false,
      activeModel: 'Select Image',
      mediaType: '2D',
      startTime: 0,
      endTime: 0,
      originalDuration: 0,
      imagesMainList: [],
      id: uuid.v1(),
      offsetHorizontal: 0,
      offsetVertical: 0,
      layer: 0,
      alignmentType: 'Center',
      positionOfOrigin: {
        X: 0,
        Y: 0,
        Z: 0
      },
      rotationOfOrigin: {
        X: 0,
        Y: 0,
        Z: 0
      },
      scaleOfOrigin: {
        X: 0,
        Y: 0,
        Z: 0
      },
      mediaWidth: 0,
      mediaHeight: 0,
      selectedLogic: null,
      activeImage: null
    }
  },
  created () {
    this.listMediaImages()
    this.getActiveImage()
  },
  mounted () {
    // this.mainCharacterIndex = this.currentIndex

  },
  methods: {
    ...mapActions([
      'listMediaImages'
    ]),
    horizontalAlignment(value) {
      this.activeImage.objectTransformSimple.horizontal = value;
    },
    verticalAlignment(value) {
      this.activeImage.objectTransformSimple.vertical = value;
    },
    changeLayer(value) {
      this.activeImage.layer  += value;
    },
    bringToFront() {
      this.activeImage.layer = this.layerStep
    },
    sendToBack() {
      this.activeImage.layer = - this.layerStep
    },
    getSceneImages () {
      this.selectedLogic = JSON.parse(localStorage.getItem('selectedLogic'))
      let selectedNodePosition = this.selectedLogic.nodePosition
      let tRef = db.ref().child('stories/' + localStorage.getItem('storyId'))
      tRef.on('value', snapshot => {
        let json = snapshot.val().json
        if (json.mainStory.nodes[selectedNodePosition].nodeElements) {
          this.imagesMainList = []
          for (const key in json.mainStory.nodes[selectedNodePosition].nodeElements) {
            if (json.mainStory.nodes[selectedNodePosition].nodeElements[key].hasOwnProperty('object2D') &&
                json.mainStory.nodes[selectedNodePosition].nodeElements[key].object2D.typeOfDisplay === 'Image') {
              if (!this.currentSelectedImageNode) {
                this.currentSelectedImageNode = json.mainStory.nodes[selectedNodePosition].nodeElements[key].object2D.objectId
                setTimeout(() => {
                  this.currentSelectedImage = json.mainStory.nodes[selectedNodePosition].nodeElements[key].object2D.objectDbHash
                  this.startTime = json.mainStory.nodes[selectedNodePosition].nodeElements[key].object2D.startTime || this.startTime
                  this.endTime = json.mainStory.nodes[selectedNodePosition].nodeElements[key].object2D.endTime || this.endTime
                  this.originalDuration = json.mainStory.nodes[selectedNodePosition].nodeElements[key].object2D.objectLength || this.endTime - this.startTime
                  this.mediaHeight = json.mainStory.nodes[selectedNodePosition].nodeElements[key].object2D.objectSizeDelta.height || this.mediaHeight
                  this.mediaWidth = json.mainStory.nodes[selectedNodePosition].nodeElements[key].object2D.objectSizeDelta.width || this.mediaWidth
                  this.offsetHorizontal = json.mainStory.nodes[selectedNodePosition].nodeElements[key].object2D.objectTransformSimple.offsetHorizontal || this.offsetHorizontal
                  this.offsetVertical = json.mainStory.nodes[selectedNodePosition].nodeElements[key].object2D.objectTransformSimple.offsetVertical || this.offsetVertical
                  this.positionOfOrigin.X = json.mainStory.nodes[selectedNodePosition].nodeElements[key].object2D.positionOfOrigin[0] || this.positionOfOrigin.X
                  this.positionOfOrigin.Y = json.mainStory.nodes[selectedNodePosition].nodeElements[key].object2D.positionOfOrigin[1] || this.positionOfOrigin.Y
                  this.positionOfOrigin.Z = json.mainStory.nodes[selectedNodePosition].nodeElements[key].object2D.positionOfOrigin[2] || this.positionOfOrigin.Z
                  this.rotationOfOrigin.X = json.mainStory.nodes[selectedNodePosition].nodeElements[key].object2D.rotationOfOrigin[0] || this.rotationOfOrigin.X
                  this.rotationOfOrigin.Y = json.mainStory.nodes[selectedNodePosition].nodeElements[key].object2D.rotationOfOrigin[1] || this.rotationOfOrigin.Y
                  this.rotationOfOrigin.Z = json.mainStory.nodes[selectedNodePosition].nodeElements[key].object2D.rotationOfOrigin[2] || this.rotationOfOrigin.Z
                  this.scaleOfOrigin.X = json.mainStory.nodes[selectedNodePosition].nodeElements[key].object2D.scaleOfOrigin[0] || this.scaleOfOrigin.X
                  this.scaleOfOrigin.Y = json.mainStory.nodes[selectedNodePosition].nodeElements[key].object2D.scaleOfOrigin[1] || this.scaleOfOrigin.Y
                  this.scaleOfOrigin.Z = json.mainStory.nodes[selectedNodePosition].nodeElements[key].object2D.scaleOfOrigin[2] || this.scaleOfOrigin.Z
                  this.mediaType = json.mainStory.nodes[selectedNodePosition].nodeElements[key].object2D.objectType || this.mediaType
                  this.layer = json.mainStory.nodes[selectedNodePosition].nodeElements[key].object2D.layer || this.layer
                  this.alignmentType = json.mainStory.nodes[selectedNodePosition].nodeElements[key].object2D.alignmentType || this.alignmentType
                }, 500)
              }
              this.imagesMainList.push(json.mainStory.nodes[selectedNodePosition].nodeElements[key].object2D)
            }
          }
        }
        if (!this.imagesMainList.length) {
          this.showModal = true
          this.$nextTick(() => {
            $('#character-modal').modal('show')
          })
        }
      })
    },
    getActiveImage() {
      let found = false
      for (let i = 0; i < this.characters.length; i++) {
        const char = this.characters[i]
        if (char.active) {
          this.activeImage = char
          found = true
        }
      }
      if (!found) {
        this.activeImage = this.characters[0]
      }
    },
    updatedSelectedImage (value) {
      this.currentSelectedImage = value
      this.id = uuid.v1()
      this.imagesMainList.push({
        'objectId': this.id,
        'objectName': this.getMediaImages[this.currentSelectedImage].name,
        'objectDbHash': this.currentSelectedImage
      })
      this.startTime = 0
      this.endTime = this.getMediaImages[this.currentSelectedImage].duration || 0
      this.originalDuration = this.getMediaImages[this.currentSelectedImage].duration || 0
      this.currentSelectedImageNode = this.id
      this.mediaType = this.getMediaImages[this.currentSelectedImage].typeOfImage || '2D'
      this.mediaWidth = this.getMediaImages[this.currentSelectedImage].mediaWidth
      this.mediaHeight = this.getMediaImages[this.currentSelectedImage].mediaHeight
      this.offsetHorizontal = this.getMediaImages[this.currentSelectedImage].offsetHorizontal
      this.offsetVertical = this.getMediaImages[this.currentSelectedImage].offsetVertical
      this.layer = this.getMediaImages[this.currentSelectedImage].layer || 0
      this.alignmentType = this.getMediaImages[this.currentSelectedImage].alignmentType || 'Center'
      this.positionOfOrigin = this.getMediaImages[this.currentSelectedImage].hasOwnProperty('positionOfOrigin') ? this.getMediaImages[this.currentSelectedImage].positionOfOrigin : this.positionOfOrigin
      this.rotationOfOrigin = this.getMediaImages[this.currentSelectedImage].hasOwnProperty('rotationOfOrigin') ? this.getMediaImages[this.currentSelectedImage].rotationOfOrigin : this.rotationOfOrigin
      this.scaleOfOrigin = this.getMediaImages[this.currentSelectedImage].hasOwnProperty('scaleOfOrigin') ? this.getMediaImages[this.currentSelectedImage].scaleOfOrigin : this.scaleOfOrigin
      this.closeModal()
    },
    saveToDB () {
      let selectedNodePosition = this.selectedLogic.nodePosition
      let tRef = db.ref().child('stories/' + localStorage.getItem('storyId'))
      tRef.once('value').then(async snapshot => {
        let json = snapshot.val().json
        let updates = {}
        let keyExist = null
        let mediaExist = false
        let firstNode = false
        // if (
        //   !json.mainStory.nodes[selectedNodePosition].hasOwnProperty('nodeElements')
        // ) {
        //   firstNode = true
        // }
        let position = []
        position.push(this.positionOfOrigin.X)
        position.push(this.positionOfOrigin.Y)
        position.push(this.positionOfOrigin.Z)
        let rotation = []
        rotation.push(this.rotationOfOrigin.X)
        rotation.push(this.rotationOfOrigin.Y)
        rotation.push(this.rotationOfOrigin.Z)
        let scale = []
        scale.push(this.scaleOfOrigin.X)
        scale.push(this.scaleOfOrigin.Y)
        scale.push(this.scaleOfOrigin.Z)
        let finalData = {
          elementType: 'object2D',
          object2D: {
            'objectId': this.id,
            'objectName': this.getMediaImages[this.currentSelectedImage]['name'],
            'typeOfDisplay': 'Image',
            'objectType': this.mediaType,
            'objectDescription': this.getMediaImages[this.currentSelectedImage]['description'],
            'objectDbHash': this.currentSelectedImage,
            'objectLength': this.originalDuration,
            'startTime': this.startTime,
            'endTime': this.endTime,
            'objectUrl': this.getMediaImages[this.currentSelectedImage]['image']['imageURL'],
            'layer': this.layer,
            'alignmentType': this.alignmentType,
            'positionOfOrigin': position,
            'rotationOfOrigin': rotation,
            'scaleOfOrigin': scale,
            'simpleTransform': true,
            'objectTransformSimple': {
              'offsetHorizontal': this.offsetHorizontal,
              'offsetVertical': this.offsetVertical
            },
            'objectSizeDelta': {
              'width': this.mediaWidth,
              'height': this.mediaHeight
            }
          }
        }
        if (selectedNodePosition >= 0) {
          let nodeElements = json.mainStory.nodes[selectedNodePosition].nodeElements
          if (nodeElements) {
            for (const nodeElement in nodeElements) {
              mediaExist = true
              if (nodeElements[nodeElement].elementType === 'object2D') {
                const imageInfo = nodeElements[nodeElement].object2D
                if (imageInfo.typeOfDisplay === 'Image' && imageInfo.objectDbHash === this.currentSelectedImage) {
                  this.id = this.currentSelectedImageNode
                  keyExist = imageInfo
                  break
                }
              }
            }
          }
          let key = ''
          for (const snapshotkey in nodeElements) {
            if (
              nodeElements[snapshotkey].hasOwnProperty(
                'object2D'
              ) &&
              nodeElements[snapshotkey].object2D.objectDbHash === finalData.object2D.objectDbHash
            ) {
              key = snapshotkey
              if (
                nodeElements[snapshotkey].object2D
                  .object2DElements
              ) {
                finalData.object2D.object2DElements = []
                for (const innerKey in nodeElements[snapshotkey].object2D.object2DElements) {
                  finalData.object2D.object2DElements.push(
                    nodeElements[snapshotkey].object2D
                      .object2DElements[innerKey]
                  )
                }
              }
            }
          }
          if (keyExist !== null) {
            console.log('Key exist')
            console.log(json.mainStory.nodes[selectedNodePosition].nodeElements[key])
            json.mainStory.nodes[selectedNodePosition].nodeElements[key] = finalData
          } else {
              // if (!mediaExist) {
              //   json.mainStory.nodes[selectedNodePosition].nodeElements[snapshotkey]['elementType'] = 'object2D'
              //   json.mainStory.nodes[selectedNodePosition].nodeElements[snapshotkey]['object2D'] = []
              // }
            console.log('Key not exist')
            json.mainStory.nodes[selectedNodePosition].nodeElements.push(finalData)
          }
        } else {
          json.mainStory.nodes[selectedNodePosition].nodeElements.push(finalData)
        }
        updates[localStorage.getItem('storyId') + `/json`] = json
        db.ref('stories')
            .update(updates)
            .then(() => {
              this.showSuccessToast()
            })
            .catch(e => {
              this.showErrorToast()
            })
      })
    },
    showSuccessToast () {
      this.$toast('Image inspector data saved', {
        timeout: 3000,
        type: 'success',
        showCloseButtonOnHover: true
      })
    },
    showErrorToast () {
      this.$toast('Image inspector data failed', {
        timeout: 3000,
        type: 'error',
        showCloseButtonOnHover: true
      })
    },
    showAddNewImageModal: function () {
      this.showModal = true
      this.$nextTick(() => {
        $('#character-modal').modal('show')
      })
    },
    closeModal () {
      this.$nextTick(() => {
        $('#character-modal').modal('hide')
        this.showModal = false
      })
    },
    changeSelectedImage (event = null) {
      if (event) {
        let newCharacters = this.characters
        newCharacters = this.characters.map(char =>
          char.objectId === this.activeImage.objectId
            ? {
              ...char,
              objectDbHash: event.target.value,
              objectName: this.getMediaImages[event.target.value].name,
              endTime: this.activeImage.startTime + this.getMediaImages[event.target.value].duration,
              displayType: this.getMediaImages[event.target.value].displayType || this.activeImage.displayType,
              objectDescription: this.getMediaImages[event.target.value].description || '',
              objectUrl: this.getMediaImages[event.target.value].image.imageURL,
              duration: this.getMediaImages[event.target.value].duration || this.activeImage.duration,
              layer: this.getMediaImages[event.target.value].layer || 0,
              objectSizeDelta: {
                width: this.getMediaImages[event.target.value].mediaWidth || 200,
                height: this.getMediaImages[event.target.value].mediaHeight || 200
              },
              objectTransformSimple: {
                  horizontal: this.activeImage.objectTransformSimple.horizontal,
                  vertical: this.activeImage.objectTransformSimple.vertical,
                  offsetHorizontal: this.getMediaImages[event.target.value].offsetHorizontal || 0,
                  offsetVertical: this.getMediaImages[event.target.value].offsetVertical || 0,
              },
            }
            : { ...char }
        )
        this.$store.dispatch('updateCharacters', [])
        this.$store.dispatch('updateCharacters', newCharacters)
      }
    },
    changeSelectedImageNode () {
      for (const key in this.imagesMainList) {
        if (this.imagesMainList[key].objectId === this.currentSelectedImageNode) {
          console.log('condition True')
          this.currentSelectedImage = this.imagesMainList[key].objectDbHash
          this.startTime = this.imagesMainList[key].startTime
          this.endTime = this.imagesMainList[key].endTime || 0
          this.originalDuration = this.imagesMainList[key].objectLength || 0
          this.currentSelectedImageNode = this.imagesMainList[key].objectId
          this.mediaType = this.imagesMainList[key].objectType || '2D'
          this.mediaWidth = this.imagesMainList[key].objectWidth
          this.mediaHeight = this.imagesMainList[key].objectHeight
          this.offsetHorizontal = this.imagesMainList[key].offsetHorizontal
          this.offsetVertical = this.imagesMainList[key].offsetVertical
          this.layer = this.imagesMainList[key].layer || 0
          this.alignmentType = this.imagesMainList[key].alignmentType || 'Center'
          this.positionOfOrigin.X = this.imagesMainList[key].positionOfOrigin[0]
          this.positionOfOrigin.Y = this.imagesMainList[key].positionOfOrigin[1]
          this.positionOfOrigin.Z = this.imagesMainList[key].positionOfOrigin[2]
          this.rotationOfOrigin.X = this.imagesMainList[key].rotationOfOrigin[0]
          this.rotationOfOrigin.Y = this.imagesMainList[key].rotationOfOrigin[1]
          this.rotationOfOrigin.Z = this.imagesMainList[key].rotationOfOrigin[2]
          this.scaleOfOrigin.X = this.imagesMainList[key].scaleOfOrigin[0]
          this.scaleOfOrigin.Y = this.imagesMainList[key].scaleOfOrigin[1]
          this.scaleOfOrigin.Z = this.imagesMainList[key].scaleOfOrigin[2]
        }
      }
    },
    changeTime () {
      this.activeImage.duration = (parseFloat(this.activeImage.endTime) - parseFloat(this.activeImage.startTime)).toFixed(2)
    }
  },
  watch: {
    characters (val) {
      this.getActiveImage()
    },
  },
  computed: {
    ...mapGetters([
      'getMediaImages'
    ]),
    ...mapState([
      'characters'
    ]),
  }
}
</script>
<style>
.selectSound {
  cursor: pointer;
}
.action-disabled {
  opacity: 0.2;
}
</style>



// WEBPACK FOOTER //
// src/components/v2/story-edit-view/inspector-components/media-images/maininspector.vue